import { api } from "@redux/api";
import { throttle } from "lodash";

// Action Types
export const GLOBAL_SEARCH_REQUEST = "GLOBAL_SEARCH_REQUEST";
export const GLOBAL_SEARCH_SUCCESS = "GLOBAL_SEARCH_SUCCESS";
export const GLOBAL_SEARCH_FAILURE = "GLOBAL_SEARCH_FAILURE";
export const SAVE_SEARCH_HISTORY = "SAVE_SEARCH_HISTORY";
export const SET_SELECTED_MODELS = "SET_SELECTED_MODELS";

// Action Creators
export const searchRequest = (query, models) => ({
  type: GLOBAL_SEARCH_REQUEST,
  payload: { query, models },
});

export const searchSuccess = (results) => ({
  type: GLOBAL_SEARCH_SUCCESS,
  payload: results,
});

export const searchFailure = (error) => ({
  type: GLOBAL_SEARCH_FAILURE,
  payload: error,
});

export const saveSearchHistory = (query, models) => ({
  type: SAVE_SEARCH_HISTORY,
  payload: { query, models, timestamp: Date.now() },
});

export const setSelectedModels = (models) => ({
  type: SET_SELECTED_MODELS,
  payload: models,
});

// Basic search function
const searchFunction = async (query, models, facilityId, companyId, scope, limit, dispatch) => {
  if (!query || query.length < 2) return null;

  dispatch(searchRequest(query, models));

  try {
    const modelsParam = models.join(",");
    const limitParam = limit || 20;
    let queryString = `query=${encodeURIComponent(query)}&limit=${limitParam}&models=${modelsParam}`;
    // 添加 facilityId 参数
    if (facilityId) {
      queryString += `&facilityId=${encodeURIComponent(facilityId)}`;
    }
    
    // 添加 companyId 参数
    if (companyId) {
      queryString += `&companyId=${encodeURIComponent(companyId)}`;
    }
    
    // 添加 scope 参数
    if (scope) {
      queryString += `&scope=${encodeURIComponent(scope)}`;
    }

    const response = await api.globalSearch(queryString);

    dispatch(searchSuccess(response.data));

    return response.data;
  } catch (error) {
    console.error("Search failed:", error);
    dispatch(searchFailure(error.message));
    return null;
  }
};

// Throttled search function (limit to 1 request per second)
const throttledSearch = throttle(searchFunction, 1000, {
  leading: true,
  trailing: true,
});

// Async Action Creator with throttle
export const performSearch = (query, models, facilityId = null, companyId = null, scope = 'current-facility', limit = 20) => {
  return (dispatch) => {
    if (!query || query.length < 2) return Promise.resolve(null);
    return throttledSearch(query, models, facilityId, companyId, scope, limit, dispatch);
  };
};
